module.exports = __webpack_public_path__ + "static/content1-img-99c5ec2bebe63560e629192c02165509.png";